import { all } from "@awesome.me/kit-3783617b8f/icons";
import { dom, library } from "@fortawesome/fontawesome-svg-core";

// https://docs.fontawesome.com/apis/javascript/methods#domi2svgparams
document.addEventListener("DOMContentLoaded", async () => {
  library.add(...all);
  await dom.i2svg();
});
